import React, { useEffect } from "react";
import "../css/homepage.css";
import Footer from "../components/footer";
import Header from "../components/header";

const Privacy = (props) => {
  useEffect(() => {
    document.title = "Mapli – Personvernerklæring";
  }, []);

  return (
    <div className='homePageContainer'>
      <Header faq={true} />

      <div
        className='BusinessPagesMainContainer'
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <div
          style={{
            flexDirection: "column",
            width: "40%",
          }}>
          <h1>Personvernerklæring</h1>
          <p>
            Denne personvernerklæringen gjelder for appen <strong>Mapli</strong>{" "}
            og forklarer hvordan vi samler inn, bruker og lagrer
            personopplysninger. Vi tar personvernet ditt på alvor og samler kun
            inn det som er nødvendig for at appen skal fungere som den skal.
          </p>

          <h2>Hvilke data vi samler inn</h2>

          <h3>📍 Lokasjonsdata</h3>
          <p>
            Appen bruker enhetens posisjon for å vise relevante steder i
            nærheten. Posisjonen brukes kun lokalt på enheten og sendes ikke til
            våre egne servere, men kan bli brukt av tredjepartstjenester (som
            Google AdMob og Firebase Analytics) for anonyme statistikkformål.
          </p>

          <h3>🔥 Firebase</h3>
          <ul>
            <li>
              <strong>Firebase Firestore:</strong> Brukes for å hente og vise
              data knyttet til steder og arrangementer. Vi lagrer ikke personlig
              identifiserbar informasjon.
            </li>
            <li>
              <strong>Firebase Analytics:</strong> Brukes for å forstå hvordan
              appen brukes (f.eks. hvilke skjermer som åpnes). Dataen er anonym
              og brukes kun til å forbedre brukeropplevelsen.
            </li>
          </ul>

          <h3>📢 Google AdMob</h3>
          <p>
            Google AdMob viser annonser i appen. AdMob kan bruke enhetens
            informasjon (f.eks. enhets-ID, IP-adresse og omtrentlig posisjon)
            for å vise mer relevante annonser. Du kan lese mer om dette hos{" "}
            <a
              href='https://policies.google.com/technologies/ads'
              target='_blank'
              rel='noopener noreferrer'>
              Google’s Privacy & Terms
            </a>
            .
          </p>

          <h2>Deling av data</h2>
          <p>
            Vi selger eller deler ikke dine personopplysninger med andre
            selskaper. Data behandles kun av tjenesteleverandører som Google
            (AdMob, Firebase) i henhold til deres egne retningslinjer.
          </p>

          <h2>Lagring og sikkerhet</h2>
          <p>
            Vi samler ikke inn personlig identifiserbar informasjon. Data som
            vises i appen lagres i Google Firebase, som følger
            industristandarder for sikkerhet.
          </p>

          <h2>Dine rettigheter</h2>
          <p>Du kan til enhver tid:</p>
          <ul>
            <li>Slå av posisjonstilgang i enhetens innstillinger</li>
            <li>Avinstallere appen for å stoppe all datainnsamling</li>
          </ul>

          <h2>Kontakt oss</h2>
          <p>
            Har du spørsmål om personvernet ditt? Kontakt oss på:{" "}
            <a href='mailto:support@mapli.no'>support@mapli.no</a>
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Privacy;
